<template>
  <a-card class="box-form-page">
    <div class="box-form-cancel-steps" v-if="editForm.OPER_STATUS === 3">
      <a-steps :current="current">
        <a-step v-for="item in cancelSteps" :key="item.title" :title="item.title"/>
      </a-steps>
    </div>
    <div class="box-form-cancel-steps" v-else-if="editForm.OPER_STATUS === 4">
      <a-steps :current="current">
        <a-step v-for="item in rejectSteps" :key="item.title" :title="item.title"/>
      </a-steps>
    </div>
    <div v-else class="box-form-steps">
      <a-steps :current="current">
        <a-step v-for="item in steps" :key="item.title" :title="item.title"/>
      </a-steps>
    </div>
    <!--    <div v-if="current === 0" style="font-size: 22px;font-weight: 600">{{$t('applyUserBoxHint')}}</div>-->
    <!--用箱申请标题-->
    <div v-if="current === 0" class="box-form-title">
      {{ $t('useBoxApply') }}
    </div>

    <!--用箱申请表单-->
    <div class="steps-content" v-if="current === 0">
      <template>
        <dol-form-model class="user-box-form" :model="editForm" :rules="validateRules" ref="editForm">
          <a-row>
            <a-col :span="11">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="CITY_ID">
                <template slot="label">
                  <span class="user-box-form-span">{{ $t('takeBoxPlace') }}</span>
                </template>
                <dol-select
                    width="100%"
                    v-model.trim="editForm.CITY_ID"
                    source="server"
                    server-type="DotNet"
                    dot-net-table-name="GM_CITY"
                    :label-field="$kt('CITY_NAME')"
                    key-field="CITY_ID"
                    value-field="CITY_ID"
                    size="large"
                    @change="(val, data) =>checkPrice(val, data, 'left')"
                    ref="nation"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="11" :offset="2">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="D_CITY_ID">
                <template slot="label">
                  <span class="user-box-form-span">{{ $t('通用_还箱地') }}</span>
                </template>
                <dol-select
                    width="100%"
                    v-model.trim="editForm.D_CITY_ID"
                    source="server"
                    server-type="DotNet"
                    dot-net-table-name="GM_CITY"
                    :label-field="$kt('CITY_NAME')"
                    key-field="CITY_ID"
                    value-field="CITY_ID"
                    size="large"
                    @change="(val, data) =>checkPrice(val, data, 'right')"
                    ref="rNation"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="GOODS_TYPE">
                <template slot="label">
                  <span class="user-box-form-span">{{ $t('goodsType') }}</span>
                </template>
                <a-radio-group v-model.trim="editForm.GOODS_TYPE" size="large">
                  <a-radio style="line-height: 40px;" v-for="(item,index) in goodsOptions" :key="index"
                           :value="item.CODE_ID">
                    {{ $dt(item, 'CODE_NAME') }}
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" :offset="2">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="BOX_SIZE">
                <template slot="label">
                  <span class="user-box-form-span">{{ $t('通用_箱型') }}</span>
                </template>
                <select-box-size v-model.trim="editForm.BOX_SIZE" @change="checkPriceLocal"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="GOODS_NAME">
                <template slot="label">
                  <span class="user-box-form-span">{{ $t('goodsName') }}</span>
                </template>
                <a-input v-model.trim="editForm.GOODS_NAME" :placeholder="$t('pleaseEnterTheNameOfTheGoods')"
                         size="large"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" :offset="2">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="BOX_STATE">
                <template slot="label">
                  <span class="user-box-form-span">{{ $t('boxStatus') }}</span>
                </template>
                <dol-select
                    width="100%"
                    v-model.trim="editForm.BOX_STATE"
                    source="server"
                    server-type="DotNet"
                    dot-net-table-name="BM_BASE_CODE"
                    :label-field="$kt('CODE_NAME')"
                    key-field="CODE_ID"
                    value-field="CODE_ID"
                    :query-data="$api.baseCode['10000010']"
                    @change="checkPriceLocal"
                    size="large"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="REAL_QTY">
                <template slot="label">
                  <span class="user-box-form-span">{{ $t('通用_箱量') }}<span v-if="ROUTE_QTY">({{$t('usableBox')}}: {{ROUTE_QTY}})</span></span>
                </template>
                <a-input v-model.trim="editForm.REAL_QTY" type="number" style="width: 216px;text-align: center"
                         size="large">
                  <a-icon slot="addonAfter" type="plus" @click="changeNumber(1)"/>
                  <a-icon slot="addonBefore" type="minus" @click="changeNumber(-1)"/>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" :offset="2">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="UNIT_WEIGHT">
                <template slot="label">
                  <span class="user-box-form-span">{{ $t('boxWeight') }}</span>
                </template>
                <a-input v-model.trim="editForm.UNIT_WEIGHT" type="number"
                         :placeholder="$t('PleaseInputTheWeightOfEachContainer')" size="large">
                  <template slot="suffix">
                    <span style="color: #BBBBBB;">{{ $t('ton') }}</span>
                  </template>
                </a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="TRANS_WAY">
                <template slot="label">
                  <span class="user-box-form-span">{{ $t('transportationType') }}</span>
                </template>
                <a-radio-group v-model.trim="editForm.TRANS_WAY">
                  <template v-for="item in transTypeList">
                    <a-radio :value="item.code">
                      {{ $dt(item, 'text') }}
                    </a-radio>
                  </template>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" offset="2">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="SHIP_NN">
                <template slot="label">
                  <span class="user-box-form-span">{{ $t('vesselVoyage') }}</span>
                </template>
                <ship-select v-model.trim="editForm.SHIP_NN" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="ESTIM_DATE">
                <template slot="label">
                  <span class="user-box-form-span">{{ $t('expectedDateOfContainerUse') }}</span>
                </template>
                <a-date-picker :placeholder="$t('pleaseSelectADate')"
                               v-model.trim="editForm.ESTIM_DATE" style="width: 100%"
                               size="large"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" :offset="2">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="CUST_CODE">
                <template slot="label">
                  <span class="user-box-form-span">{{ $t('通用_客户订单号') }}<a-popover>
                      <template slot="content">
                        {{ $t('custOrderNoMemo') }}
                      </template>
                      <a-icon style="margin-left: 2px" type="exclamation-circle"/>
                  </a-popover></span>
                </template>
                <a-input v-model.trim="editForm.CUST_CODE" :placeholder="$t('custOrderNoMessage')" size="large"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="VALID_PRICE"
                                 v-if="matchPriceFlag">
                <template slot="label">
                  <span class="user-box-form-span">
                    {{ $t('transactionPrice') }}
                  </span>
                  <span class="user-box-form-span" style="color: red">
                    {{$t('UXSFpriceHint')}}
                  </span>
                </template>
                <a-input v-model.trim="editForm.VALID_PRICE" type="number" prefix="$" size="large" disabled/>
              </a-form-model-item>
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="HF_PRICE" v-else>
                <template slot="label">
                  <span class="user-box-form-span">
                    {{ $t('intentionPrice') }}
                  </span>
                  <span class="user-box-form-span" style="color: red">
                    {{$t('UXSFpriceHint')}}
                  </span>
                </template>
                <a-input v-model.trim="editForm.HF_PRICE" type="number" prefix="$" size="large"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}">
                <template slot="label">
                  <span class="user-box-form-span">{{ $t('通用_备注') }}</span>
                </template>
                <a-textarea
                    v-model.trim="editForm.MEMO"
                    :placeholder="$t('pleaseEnterRemarks')"
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <div style="text-align: center">
            <a-button class="user-box-form-button" type="primary" :loading="loading" @click="getNowPrice">{{$t('submit') }}</a-button>
          </div>
        </dol-form-model>
      </template>
    </div>

    <!--订单审核中显示-->
    <div class="steps-content"
         v-if="editForm.PRICE_STATUS === 0 && editForm.OPER_STATUS !== 3 && editForm.OPER_STATUS !== 4">
      <a-spin class="steps-spin" v-if="spinLoading" tip="Loading..." :delay="'500'"/>
      <template v-else>
        <div class="wait-frame">
          <div class="wait-frame-info">
            <a-avatar style="background: rgba(31,108,186,0.1)" :size="68">
              <template #icon>
                <a-icon style="color: #1F6CBA;" type="filter"/>
              </template>
            </a-avatar>
            <div class="wait-frame-info-text">
              <div class="wait-frame-info-text-top">{{ $t('waitingForThePlatformQuotation') }}</div>
              <div class="wait-frame-info-text-bottom">{{ $t('thePlatformWillHandleItAsSoonAsPossible') }}</div>
            </div>
          </div>
          <div class="wait-frame-right">
          </div>
        </div>
        <a-card class="user-apply-info" :body-style="{padding:'24px 35px'}">
          <template slot="title">
            <div class="user-apply-info-title">
              <div>{{ $t('useBoxApplyInfo') }}（{{ $t('orderID') }}：{{editForm.SHEET_CODE}}）</div>
              <template v-if="editForm.VALID_PRICE">
                <div>{{ $t('transactionPrice') }}: ${{ editForm.VALID_PRICE }}</div>
              </template>
                <template v-else-if="editForm.HF_PRICE > 0">
                  <div>{{ $t('intentionPrice') }}: ${{ editForm.HF_PRICE }}</div>
                </template>
                <template v-else>
                  <div>{{ $t('subsidizePrices') }}: ${{ editForm.HF_PRICE * -1 }}</div>
                </template></div>
          </template>
          <a-descriptions class="user-apply-info-descriptions">
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('useBoxDate') }}</span>
              </template>
              <span>{{ moment(editForm.ESTIM_DATE).format('YYYY-MM-DD') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('takeBoxPlace') }}</span>
              </template>
              <span>{{ $dt(editForm, 'CITY_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('通用_还箱地') }}</span>
              </template>
              <span>{{ $dt(editForm, 'D_CITY_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('goodsType') }}</span>
              </template>
              <span>{{ $dt(editForm, 'GOODS_TYPE_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('通用_箱型') }}</span>
              </template>
              <span>{{ $dt(editForm, 'BOX_SIZE_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('boxWeight') }}</span>
              </template>
              <span>{{ editForm.UNIT_WEIGHT }}t</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('goodsName') }}</span>
              </template>
              <span>{{ editForm.GOODS_NAME }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('通用_箱量') }}</span>
              </template>
              <span>{{ editForm.REAL_QTY }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('transportationType') }}</span>
              </template>
              <span>{{ $dt(editForm, 'TRANS_WAY_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('通用_客户订单号') }}</span>
              </template>
              <span>{{ editForm.CUST_CODE }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('通用_备注') }}</span>
              </template>
              <span>{{ editForm.MEMO }}</span>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>
      </template>
    </div>

    <!--订单审核后显示-->
    <div class="steps-content" v-if="current === 2">
      <a-spin class="steps-spin" v-if="spinLoading" tip="Loading..." delay="500"/>
      <template v-else>
        <div class="wait-frame">
          <div class="wait-frame-info">
            <a-avatar style="background: rgba(31,108,186,0.1)" :size="68">
              <template #icon>
                <a-icon style="color: #1F6CBA;" type="safety-certificate"/>
              </template>
            </a-avatar>
            <div class="wait-frame-info-text">
              <div class="wait-frame-info-text-top">{{ $t('boxApplyFormFinishTitle') }}</div>
              <div class="wait-frame-info-text-bottom">{{ $t('boxApplyFormFinishHint') }}</div>
            </div>
          </div>
        </div>
        <a-card class="user-apply-info" :body-style="{padding:'24px 35px'}">
          <template slot="title">
            <div class="user-apply-info-title">{{ $t('useBoxApplyInfo') }}（{{ $t('orderID') }}：{{editForm.SHEET_CODE}}）</div>
          </template>
          <a-descriptions class="user-apply-info-descriptions">
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('expectedDateOfContainerUse') }}</span>
              </template>
              <span>{{ $moment(editForm.ESTIM_DATE).format('YYYY-MM-DD') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('takeBoxPlace') }}</span>
              </template>
              <span>{{ $dt(editForm, 'CITY_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('takeBoxPlace') }}</span>
              </template>
              <span>{{ $dt(editForm, 'D_CITY_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('goodsType') }}</span>
              </template>
              <span>{{ $dt(editForm, 'GOODS_TYPE_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('通用_箱型') }}</span>
              </template>
              <span>{{ $dt(editForm, 'BOX_SIZE_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('boxWeight') }}</span>
              </template>
              <span>{{ editForm.UNIT_WEIGHT }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('goodsName') }}</span>
              </template>
              <span>{{ editForm.GOODS_NAME }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('通用_箱量') }}</span>
              </template>
              <span>{{ editForm.REAL_QTY }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('通用_客户订单号') }}</span>
              </template>
              <span>{{ editForm.CUST_CODE }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('通用_备注') }}</span>
              </template>
              <span>{{ editForm.MEMO }}</span>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>
        <a-card class="offer-apply-info">
          <template slot="title">
            <div class="offer-apply-info-title">
              {{ $t('quotationInformation') }}
            </div>
          </template>
          <dol-list
              class="dol-list-style"
              :dot-net-columns="false"
              title=""
              :columns="columns"
              :pagination="false"
              source="local"
              :row-key="'FLOW_ID'"
              :row-index="true"
              :defaultData="cargoPriceList"
              ref="list"
          >
            <template #operation="field, record"></template>
          </dol-list>
          <div class="offer-apply-hint">
            <div class="offer-apply-hint-left">{{ $t('returnBoxHint') }}</div>
            <div class="offer-apply-hint-right">
              <div class="offer-apply-hint-day">{{ $t('useBoxDay') }}：<span style="color: #E02121">{{
                  useDays || 0
                }}</span>{{ $t('day') }}
              </div>
              <div class="offer-apply-hint-right-price">{{ $t('toBePaid') }}：<span style="color: #E02121">${{
                  priceTotal
                }}</span>
              </div>
            </div>
          </div>
          <div class="offer-apply-notes">
            <div class="offer-apply-notes-title">{{ $t('applyOrderPactTitle') }}</div>
            <div v-html="$t('applyOrderPactContent')"></div>
          </div>
        </a-card>
      </template>
    </div>

    <!--订单显示时显示-->
    <div class="steps-content" v-if="editForm.OPER_STATUS === 3 || editForm.OPER_STATUS === 4">
      <a-spin class="steps-spin" v-if="spinLoading" tip="Loading..." :delay="'500'"/>
      <template v-else>
        <div class="wait-frame">
          <div class="wait-frame-info">
            <a-avatar style="background: rgba(31,108,186,0.1)" :size="68">
              <template #icon>
                <img src="../../../public/static/icon/cancel.svg"/>
              </template>
            </a-avatar>
            <div class="wait-frame-info-undone-text">
              <div class="wait-frame-info-text-top">{{
                  editForm.OPER_STATUS === 3 ? $t('undone') : $t('通用_已拒绝')
                }}
              </div>
              <div v-if="editForm.OPER_STATUS === 3" class="wait-frame-info-text-bottom">{{ $t('revocationCause') }}:
                {{ this.editForm.DELETE_DESC }}
              </div>
              <div v-else class="wait-frame-info-text-bottom">{{ $t('refusalCause') }}:
                {{ this.editForm.DELETE_DESC }}
              </div>
            </div>
          </div>
          <div class="wait-frame-right">
            <!--            <a-space>
                          <a-button class="wait-frame-button" @click="cancelReasonVisible = true">撤销申请</a-button>
                        </a-space>-->
            <!--            <a-button class="wait-frame-button">修改申请</a-button>-->
          </div>
        </div>
        <a-card class="user-apply-info" :body-style="{padding:'24px 35px'}">
          <template slot="title">
            <div class="user-apply-info-title">
              {{ $t('useBoxApplyInfo') }}（{{ $t('orderID') }}：{{editForm.SHEET_CODE}}）
            </div>
          </template>
          <a-descriptions class="user-apply-info-descriptions">
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('useBoxDate') }}</span>
              </template>
              <span>{{ moment(editForm.ESTIM_DATE).format('YYYY-MM-DD') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('takeBoxPlace') }}</span>
              </template>
              <span>{{ $dt(editForm, 'CITY_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('通用_还箱地') }}</span>
              </template>
              <span>{{ $dt(editForm, 'D_CITY_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('goodsType') }}</span>
              </template>
              <span>{{ $dt(editForm, 'GOODS_TYPE_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('通用_箱型') }}</span>
              </template>
              <span>{{ $dt(editForm, 'BOX_SIZE_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('boxWeight') }}</span>
              </template>
              <span>{{ editForm.UNIT_WEIGHT }}t</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('goodsName') }}</span>
              </template>
              <span>{{ editForm.GOODS_NAME }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('通用_箱量') }}</span>
              </template>
              <span>{{ editForm.REAL_QTY }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('transportationType') }}</span>
              </template>
              <span>{{ $dt(editForm, 'TRANS_WAY_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('通用_客户订单号') }}</span>
              </template>
              <span>{{ editForm.CUST_CODE }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                <span>{{ $t('通用_备注') }}</span>
              </template>
              <span>{{ editForm.MEMO }}</span>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>
      </template>
    </div>

    <a-modal v-model.trim="cancelReasonVisible" title="取消申请" :okText="$t('confirm')" :cancelText="$t('cancel')"
             @ok="cancelApply()" centered>
      <a-textarea v-model.trim="CANCEL_REFUSE_DESC" placeholder="请输入取消申请原因" :auto-size="{ minRows: 6 }"/>
    </a-modal>

    <a-modal v-model.trim="reasonVisible" title="拒绝报价" :okText="$t('confirm')" :cancelText="$t('cancel')"
             @ok="rejectOrder()" centered>
      <a-textarea v-model.trim="REFUSE_DESC" placeholder="请输入拒绝报价原因" :auto-size="{ minRows: 6 }"/>
    </a-modal>
  </a-card>
</template>

<script>
import moment from "moment";
import changeNation from "@/components/common/changeNation";
import selectBoxSize from "@/components/common/selectBoxSize";
import ShipSelect from '@/components/contcircle/form/ship-select.vue';

export default {
  name: "boxApplyForm",
  components: { ShipSelect, changeNation, selectBoxSize},
  data() {
    return {
      transTypeList: [],
      current: null,
      spinLoading: true,
      moment,
      steps: [
        {title: this.$t('submitPpplications'),},
        {title: this.$t('checkPending'),},
        {title: this.$t('passed'),},
      ],
      cancelSteps: [
        {title: this.$t('submitPpplications'),},
        {title: this.$t('withdrawTheClaim')},
      ],
      rejectSteps: [
        {title: this.$t('submitPpplications'),},
        {title: this.$t('withdrawTheClaim')},
      ],
      validateRules: {
        CITY_ID: [{
          required: true,
          message: this.$t('pleaseSelectAPlaceToPickUpYourSuitcase'),
          trigger: ['blur', 'change']
        }],
        D_CITY_ID: [{
          required: true,
          message: this.$t('pleaseSelectAPlaceToPickUpYourSuitcase'),
          trigger: ['blur', 'change']
        }],
        BOX_SIZE: [{required: true, message: this.$t('pleaseSelectBoxType'), trigger: ['blur', 'change']}],
        REAL_QTY: [
          {required: true, message: this.$t('pleaseFillInTheNumberOfBoxes'), trigger: ['blur', 'change']},
          {
            validator: (rule, value, callback) => {
              if (value <= 0) {
                callback(this.$t('theNumberOfBoxCharactersEnteredCannotBeNegative'));
              } else if ( this.ROUTE_QTY && value > this.ROUTE_QTY) {
                callback(this.$t('usableBoxCheck'));
              } else {
                callback();
              }
            }
          }
        ],
        BOX_STATE: [{required: true, message: this.$t('pleaseSelectTheBoxStatus'), trigger: ['blur', 'change']}],
        UNIT_WEIGHT: [{
          required: true,
          message: this.$t('pleaseFillInTheWeightOfEachCarton'),
          trigger: ['blur', 'change']
        }],
        GOODS_TYPE: [{required: true, message: this.$t('pleaseSelectTheTypeOfGoods'), trigger: ['blur', 'change']}],
        GOODS_NAME: [{required: true, message: this.$t('pleaseEnterTheNameOfTheGoods'), trigger: ['blur', 'change']}],
        ESTIM_DATE: [{required: true, message: this.$t('pleaseSelectUseDate'), trigger: ['blur', 'change']}],
        TRANS_WAY: [{required: true, message: this.$t('pleaseSelectAShippingType'), trigger: ['blur', 'change']}],
        // CUST_CODE: [{required: true, message: this.$t('custOrderNoMessage'), trigger: ['blur', 'change']}],
      },
      editForm: {
        REAL_QTY: 1,
        NATION_ID: 10000005,
        D_NATION_ID: 10000006,
        ESTIM_DATE: null
      },
      goodsOptions: [],
      orderForm: {},
      classFlag: true,
      reasonVisible: false,
      cancelReasonVisible: false,
      REFUSE_DESC: '',
      containerPriceList: [],
      cargoPriceList: [],
      loading: false,
      orderCode: '',
      CANCEL_REFUSE_DESC: '',

      cityPriceList: [],
      cityPriceFlag: null,
      matchPriceFlag: false,
      nowPrice: null,
      ROUTE_QTY: 0,
    };
  },
  watch: {
    '$i18n.locale'() {
      this.steps = [
        {title: this.$t('submitPpplications'),},
        {title: this.$t('checkPending'),},
        {title: this.$t('passed'),},
      ];
    }
  },
  computed: {
    time() {
      return this.moment(this.editForm.ESTIM_DATE).diff(this.moment(), 'days');
    },
    priceTotal() {
      let price = 0;
      this.cargoPriceList.forEach(item => {
        price += (item.REAL_QTY * item.VALID_PRICE);
      });
      return price;
    },
    useDays() {
      return this.cargoPriceList?.[0]?.['USE_DAYS'] || 0;
    },
    columns() {
      let columns = [];
      columns.push({
        dataIndex: this.$kt('CITY_NAME'),
        title: `${this.$t('takeBoxPlace')}/${this.$t('通用_还箱地')}`
      });
      columns.push({dataIndex: this.$kt('BOX_STATE_NAME'), title: this.$t('boxStatus')});
      columns.push({dataIndex: this.$kt('BOX_SIZE_NAME'), title: this.$t('通用_箱型')});
      columns.push({dataIndex: 'REAL_QTY', title: this.$t('通用_箱量')});
      columns.push({dataIndex: 'VALID_PRICE', title: this.$t('rentalPrice')});
      columns.push({dataIndex: '_id', width: '40px', scopedSlots: {customRender: 'operation'}});
      return columns;
    },
    plateColumns() {
      let columns = [];
      columns.push({dataIndex: 'RN', width: '35px', title: '#'});
      columns.push({dataIndex: this.$kt('CITY_NAME'), title: this.$t('takeBoxPlace')});
      columns.push({dataIndex: 'D_CITY_NAME', title: this.$t('通用_还箱地')});
      columns.push({dataIndex: 'BOX_SIZE_NAME', title: this.$t('通用_箱型')});
      columns.push({dataIndex: 'BOX_STATE_NAME', title: this.$t('boxStatus')});
      columns.push({dataIndex: 'REAL_QTY', title: this.$t('通用_箱量')});
      /*columns.push({dataIndex: 'USER_DATE', title: '用箱天数'});*/
      columns.push({dataIndex: 'VALID_PRICE', title: this.$t('rentalPrice')});
      columns.push({dataIndex: '_id', width: '40px', scopedSlots: {customRender: 'operation'}});

      return columns;
    },
  },
  methods: {
    disabledDate(current) {
      return current && current <= this.$moment().startOf('day');
    },
    getNation(nation, rNation) {
      this.editForm.NATION_ID = nation;
      this.editForm.D_NATION_ID = rNation;
      delete this.editForm.CITY_ID;
      delete this.editForm.D_CITY_ID;
    },
    rejectReasonOpen() {
      this.reasonVisible = true;
    },
    cancelApply() {
      this.$h5Api({
        type: '4006',
        data: [{"MASTER_ID": this.editForm.MASTER_ID, "DELETE_DESC": this.CANCEL_REFUSE_DESC}],
        showMessage: true
      }).then(data => {
        this.cancelReasonVisible = false;
        this.$message.info(data.message);
        this.getOrderDetail(this.$route.query.MASTER_ID);
      });
    },
    rejectOrder() {
      if (!this.REFUSE_DESC) {
        this.$message.info('拒绝原因不可为空！');
        return;
      }
      this.$h5Api({
        type: '4012',
        data: [{
          "OPER_TYPE": 0,
          "MASTER_ID": this.editForm.MASTER_ID,
          "REFUSE_DESC": this.REFUSE_DESC
        }],
        showMessage: true,
      }).then(data => {
        this.reasonVisible = false;
        this.$message.info(this.$t('operateSuccessfully'));
        this.getPriceData(this.$route.query.MASTER_ID);
        this.getOrderDetail(this.$route.query.MASTER_ID);
      });
    },
    //获取商品类型
    goodType() {
      this.$h5Api({
        type: '1001',
        data: [this.$dotNetUtil.commonQueryJson('BM_BASE_CODE', {TYPE_ID: 10000013}, 1, '')],
      }).then(({data}) => {
        this.goodsOptions = data.DATA_LIST;
      });
    },
    submit() {
      let condition = {
        "OT_SHEET_MASTER": [
          {
            "TARGET_ID": this.$store?.state?.userInfo?.COMPANY_ID,
            "CITY_ID": this.editForm.CITY_ID,
            "D_CITY_ID": this.editForm.D_CITY_ID,
            "GOODS_TYPE": this.editForm.GOODS_TYPE,
            "GOODS_NAME": this.editForm.GOODS_NAME,
            "ESTIM_DATE": this.$moment(this.editForm.ESTIM_DATE).format('YYYY-MM-DD'),
            "TRANS_WAY": this.editForm.TRANS_WAY,
            "CUST_CODE": this.editForm.CUST_CODE,
            "MEMO": this.editForm.MEMO,
            "SHEET_SRC": this.editForm.SHEET_SRC,
            "SHIP_NN": this.editForm.SHIP_NN,
          }
        ],
        "OT_SHEET_DETAIL": [
          {
            "BOX_SIZE": this.editForm.BOX_SIZE,
            "REAL_QTY": this.editForm.REAL_QTY,
            "UNIT_WEIGHT": this.editForm.UNIT_WEIGHT,
            "VALID_PRICE": this.editForm.VALID_PRICE,
            "HF_PRICE": this.editForm.HF_PRICE,
            "BOX_STATE": this.editForm.BOX_STATE,
            "PRICE_SRC_ID": this.editForm.PRICE_SRC_ID,
            "PRICE_SRC": this.editForm.PRICE_SRC,
          }
        ]
      };
      this.$h5Api({
        type: '4005',
        data: [condition]
      }).then(({data}) => {
        this.$message.success(String(this.$t('提示_货方用箱申请成功')));
        this.orderCode = data.value;
        this.getOrderDetail(data.value);
      });
    },
    getNowPrice() {
      this.$refs.editForm.validate((val) => {
        if (val) {
          let condition = {
            QUERY_TYPE: 2,
            COMPANY_ID: this.$store.state.userInfo?.COMPANY_ID,
            D_NATION: this.editForm.D_NATION_ID,
            NATION: this.editForm.NATION_ID,
            RANK_ID: '',
            CITY_IDS: `${this.editForm.CITY_ID}`,
            D_CITY_IDS: `${this.editForm.D_CITY_ID}`,
          };
          this.loading = true;

          this.$h5Api({
            type: '3001',
            data: [condition],
            showMessage: true,
            loading: false,
          }).then(({data}) => {
            const matchPrice = data['JT_COMPANY_PRICE'].find(item => item.BOX_STATE === this.editForm.BOX_STATE && item.BOX_SIZE === this.editForm.BOX_SIZE);
            if( matchPrice && matchPrice.PROM_PRICE && matchPrice.ROUTE_QTY > 0 ) {
              this.nowPrice = matchPrice.PROM_PRICE
              this.ROUTE_QTY = matchPrice.ROUTE_QTY
              this.editForm.PRICE_SRC_ID = matchPrice.PROM_PRICE_ID
              this.editForm.PRICE_SRC = 20411001
            } else if (matchPrice && matchPrice.IS_CBC === 0 && matchPrice.VALID_PRICE) {
              this.nowPrice = matchPrice.VALID_PRICE
              this.ROUTE_QTY = null
              this.editForm.PRICE_SRC_ID = null
              this.editForm.PRICE_SRC = 20411002
            } else {
              this.nowPrice = null
              this.ROUTE_QTY = null
              this.editForm.PRICE_SRC_ID = null
              this.editForm.PRICE_SRC = 20411003
            }
            if (this.nowPrice && this.nowPrice !== this.editForm.VALID_PRICE) {
              let that = this
              this.matchPriceFlag = true;
              this.$confirm({
                title: this.$t('priceChange'),
                content: this.$t('priceChangeHint') + ': $'+ this.nowPrice + ',' + this.$t('priceChangeHintEnd'),
                onOk() {
                  that.editForm.VALID_PRICE = that.nowPrice
                  that.submit()
                },
                onCancel() {
                },
              });
            } else {
              this.submit()
            }
          }).finally(e => {
            this.loading = false;
          });
        }
      });

    },
    changeNumber(e) {
      if (this.editForm.REAL_QTY + e > 0) {
        this.editForm.REAL_QTY = parseInt(this.editForm.REAL_QTY);
        this.editForm.REAL_QTY += e;
      }
    },
    getOrderDetail(MASTER_ID) {
      this.$h5Api({
        type: '4007',
        data: [{"MASTER_ID": this.orderCode || MASTER_ID}],
        showMessage: true
      }).then(({data}) => {
        if (data?.OT_SHEET_MASTER?.[0]?.PRICE_STATUS === 0) {
          this.current = 1;
        }
        // if (data?.OT_SHEET_MASTER?.[0]?.PRICE_STATUS === 1 || data?.OT_SHEET_MASTER?.[0]?.PRICE_STATUS === 3) {
        //   this.current = 2;
        //   this.getPriceData(data?.OT_SHEET_MASTER?.[0]?.MASTER_ID);
        // }
        if (data?.OT_SHEET_MASTER?.[0]?.PRICE_STATUS === 2) {
          this.current = 2;
          this.getPriceData(data?.OT_SHEET_MASTER?.[0]?.MASTER_ID);
        }
        if (data?.OT_SHEET_MASTER?.[0]?.OPER_STATUS === 3 || data?.OT_SHEET_MASTER?.[0]?.OPER_STATUS === 4) {
          this.current = 1;
        }
        this.editForm = data?.OT_SHEET_MASTER?.[0];
        this.spinLoading = false;
      });
    },
    getPriceData(MASTER_ID) {
      this.$h5Api({
        type: '4008',
        data: [{"MASTER_ID": MASTER_ID}],
        showMessage: true
      }).then(({data}) => {
        this.formatter(data);
      });
    },
    formatter(data) {
      let orderForm = {};
      let containerPriceList = [];
      let cargoPriceList = [];
      orderForm = Object.assign(data?.OT_XB_MASTER?.[0], data?.OT_XB_DETAIL?.[0]);
      let containerMap = {};
      data.OT_BOX_XD_MASTER.forEach(item => {
        containerMap[item.MASTER_ID] = item;
      });
      data.OT_BOX_XD_DETAIL.forEach(item => {
        if (containerMap[item.MASTER_ID]) {
          containerPriceList.push(Object.assign(containerMap[item.MASTER_ID], item));
        }
      });
      data.OT_XC_DETAIL.forEach(item => {
        cargoPriceList.push(Object.assign(item, data?.OT_XC_MASTER?.[0]));
      });
      this.containerPriceList = containerPriceList;
      this.cargoPriceList = cargoPriceList;
    },
    checkPrice(val, data, flag) {
      if (flag === 'left') {
        this.editForm.NATION_ID = data.NATION
      }
      if (flag === 'right') {
        this.editForm.D_NATION_ID = data.NATION
      }
      if (this.editForm.CITY_ID && this.editForm.D_CITY_ID && this.editForm.BOX_SIZE && this.editForm.BOX_STATE) {
        let condition = {
          QUERY_TYPE: 2,
          COMPANY_ID: this.$store.state.userInfo?.COMPANY_ID,
          D_NATION: this.editForm.D_NATION_ID,
          NATION: this.editForm.NATION_ID,
          RANK_ID: '',
          CITY_IDS: `${this.editForm.CITY_ID}`,
          D_CITY_IDS: `${this.editForm.D_CITY_ID}`,
        };
        this.loading = true;

        this.$h5Api({
          type: '3001',
          data: [condition],
          showMessage: true,
          loading: false,
        }).then(({data}) => {
          this.cityPriceList = data['JT_COMPANY_PRICE'];
          this.cityPriceFlag = `${this.editForm.CITY_ID}_${this.editForm.D_CITY_ID}`;
          this.checkPriceLocal();
        }).finally(e => {
          this.loading = false;
        });
      }
    },
    checkPriceLocal() {
      this.editForm.HF_PRICE = null
      if (this.editForm.CITY_ID && this.editForm.D_CITY_ID && this.editForm.BOX_SIZE && this.editForm.BOX_STATE) {
        if (this.cityPriceFlag === `${this.editForm.CITY_ID}_${this.editForm.D_CITY_ID}`) {
          const matchPrice = this.cityPriceList.find(item => item.BOX_STATE === this.editForm.BOX_STATE && item.BOX_SIZE === this.editForm.BOX_SIZE);
          if( matchPrice && matchPrice.PROM_PRICE && matchPrice.ROUTE_QTY > 0) {
            if(this.editForm.VALID_PRICE && this.editForm.VALID_PRICE !== matchPrice.PROM_PRICE){
              this.$message.warn(`价格已发生变动，从【${this.editForm.VALID_PRICE}】 变更为 【${matchPrice.PROM_PRICE}】，请确认后提交下单`)
            }
            this.$set(this.editForm, 'VALID_PRICE', matchPrice.PROM_PRICE);
            this.ROUTE_QTY = matchPrice.ROUTE_QTY;
            this.matchPriceFlag = true;
          } else if (matchPrice && matchPrice.IS_CBC === 0 && matchPrice.VALID_PRICE ) {
            if(this.editForm.VALID_PRICE && this.editForm.VALID_PRICE !== matchPrice.VALID_PRICE){
              this.$message.warn(`价格已发生变动，从【${this.editForm.VALID_PRICE}】 变更为 【${matchPrice.VALID_PRICE}】，请确认后提交下单`)
            }
            this.$set(this.editForm, 'VALID_PRICE', matchPrice.VALID_PRICE);
            this.ROUTE_QTY = null;
            this.matchPriceFlag = true;
          } else {
            if(this.editForm.VALID_PRICE){
              this.$set(this.editForm, 'HF_PRICE', this.editForm.VALID_PRICE);
            }
            this.$set(this.editForm, 'VALID_PRICE', '');
            this.ROUTE_QTY = null;
            this.matchPriceFlag = false;
          }
        } else {
          this.checkPrice();
        }
      }
    },
  },
  created() {
    if (this.$route.query.MASTER_ID) {
      this.getOrderDetail(this.$route.query.MASTER_ID);
    } else {
      this.current = 0;
    }
    this.goodType();

    if (this.$route.params?.NATION_ID) {
      this.$set(this.editForm, 'NATION_ID', this.$route.params?.NATION_ID);
      this.$set(this.editForm, 'D_NATION_ID', this.$route.params?.D_NATION_ID);
      this.$set(this.editForm, 'CITY_ID', this.$route.params?.CITY_ID);
      this.$set(this.editForm, 'D_CITY_ID', this.$route.params?.D_CITY_ID);
      this.$set(this.editForm, 'BOX_SIZE', this.$route.params?.BOX_SIZE);
      this.$set(this.editForm, 'VALID_PRICE', this.$route.params?.VALID_PRICE || '');
      // this.$set(this.editForm, 'HF_PRICE', this.$route.params?.VALID_PRICE);
      if(this.$route.params?.BOX_STATE) this.$set(this.editForm, 'BOX_STATE', this.$route.params?.BOX_STATE);
      this.$set(this.editForm, 'SHEET_SRC', this.$route.params?.SHEET_SRC);
    }
    if (this.$route.params?.BOX_SIZE) {
      this.$set(this.editForm, 'BOX_SIZE', this.$route.params?.BOX_SIZE);
    }
    if (this.$route.params?.ROUTE_QTY) {
      this.ROUTE_QTY = this.$route.params?.ROUTE_QTY
    }
    if (this.$route.params?.REAL_QTY) {
      this.$set(this.editForm, 'REAL_QTY', this.$route.params.REAL_QTY);
    }
    if (this.$route.params?.GOODS_TYPE) {
      this.$set(this.editForm, 'GOODS_TYPE', this.$route.params.GOODS_TYPE);
    }
    if (this.$route.params?.GOODS_NAME) {
      this.$set(this.editForm, 'GOODS_NAME', this.$route.params.GOODS_NAME);
    }
    if (this.$route.params?.UNIT_WEIGHT) {
      this.$set(this.editForm, 'UNIT_WEIGHT', this.$route.params.UNIT_WEIGHT);
    }
    if (this.$route.params?.TRANS_WAY) {
      this.$set(this.editForm, 'TRANS_WAY', this.$route.params.TRANS_WAY);
    }
    if (this.$route.params?.VALID_PRICE) {
      this.matchPriceFlag = true;
    }
    this.$dict(2006).then(data => {
      this.transTypeList = data;
    });
    this.checkPrice()
  }
};
</script>

<style lang="scss">
.ant-card.box-form-page {
  width: 1400px !important;
  flex: none !important;
  margin-left: auto !important;
  margin-right: auto !important;

  .dol-list-style {
    .ant-card.ant-card-bordered {
      .ant-card-head {
        padding: 0;
      }

      .ant-card-body {
        padding: 0;
      }
    }
  }

  .box-form-title {
    margin: 32px 70px;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #333333;
  }

  .box-form-steps {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    height: 68px;
    background: #F6F8FB;
    padding: 0 40px;
    margin: 0 70px;
    border-radius: 4px;
  }

  .box-form-cancel-steps {
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 24px auto;
    height: 68px;
    background: #F6F8FB;
    padding: 0 50px;
  }

  .steps-content {
    width: 1200px;
    margin: 20px auto;

    .steps-spin {
      width: 100%;
      margin: 200px auto;
    }

    .steps-content-target-true {
      width: 230px;
      padding: 12px 16px 14px 16px;
      background: #1F6CBA;
      border-radius: 4px;
      margin-right: 16px;
      margin-bottom: 32px;
      cursor: pointer;

      .steps-content-target-title {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #C9D8E8;
      }

      .steps-content-target-nation {
        display: flex;
        justify-content: space-between;
        margin-top: 8px;
        font-size: 16px;
        color: #FFFFFF;
        align-items: center;
      }
    }

    .steps-content-target-false {
      cursor: pointer;
      width: 230px;
      padding: 12px 16px 14px 16px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #DDDDDD;
      margin-right: 16px;
      margin-bottom: 32px;

      .steps-content-target-title {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #999999;
      }

      .steps-content-target-nation {
        display: flex;
        justify-content: space-between;
        margin-top: 8px;
        font-size: 16px;
        color: #666666;
        align-items: center;
      }
    }

    .user-box-form {
      .user-box-form-span {
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }
    }

    .user-box-form-button {
      width: 160px;
      height: 48px;
      background: #1F6CBA;
      border-radius: 4px;
      color: #FFFFFF;
      font-weight: 600;
      font-size: 16px;
    }


    .wait-frame {
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #DDDDDD;
      padding: 24px 50px 24px 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .wait-frame-info {
        display: flex;
        word-break: break-word;

        .wait-frame-info-text {
          margin-left: 20px;

          .wait-frame-info-text-top {
            font-size: 20px;
            font-weight: 600;
            color: #1F6CBA;
          }

          .wait-frame-info-text-bottom {
            margin-top: 10px;
            color: #666666;
          }
        }

        .wait-frame-info-undone-text {
          margin-left: 20px;

          .wait-frame-info-text-top {
            font-size: 20px;
            font-weight: 600;
          }

          .wait-frame-info-text-bottom {
            margin-top: 10px;
            color: #666666;
          }
        }

      }

      .wait-frame-right {
        .wait-frame-button {
          background: #FFFFFF;
          border-radius: 2px;
          border: 1px solid #1F6CBA;
          color: #1F6CBA;
        }
      }
    }

    .user-apply-info {
      margin-top: 24px;
      border: 1px solid #DDDDDD;

      .user-apply-info-title {
        display: flex;
        justify-content: space-between;
        border-left: 4px solid #1C62A9;
        padding-left: 12px;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        line-height: 1;
      }

      .user-apply-info-descriptions {
        span {
          color: #666666;
        }
      }
    }

    .submit-apply-info {
      margin-top: 24px;
      border: 1px solid #DDDDDD;

      .submit-apply-info-title {
        border-left: 4px solid #1C62A9;
        padding-left: 12px;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        line-height: 1;
      }

      .submit-apply-info-descriptions {
        span {
          color: #666666;
        }
      }
    }

    .offer-apply-info {
      margin-top: 24px;
      border: 1px solid #DDDDDD;

      .offer-apply-info-title {
        border-left: 4px solid #1C62A9;
        padding-left: 12px;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        line-height: 1;
      }

      .offer-apply-hint {
        display: flex;
        justify-content: space-between;
        margin-top: 12px;
        align-items: center;

        .offer-apply-hint-left {
          color: #333333;
        }

        .offer-apply-hint-right {
          display: flex;
          align-items: center;

          .offer-apply-hint-day {
            font-weight: 600;
            color: #333333;
            margin-right: 39px;
          }

          .offer-apply-hint-right-price {
            font-size: 18px;
            font-weight: 600;
            color: #333333;
          }
        }
      }

      .offer-apply-notes {
        background: #F6F8FB;
        border-radius: 4px;
        padding: 20px 32px;
        display: flex;
        flex-direction: column;
        margin-top: 12px;

        .offer-apply-notes-title {
          font-weight: 600;
          color: #333333;
          margin-bottom: 8px;
        }

        span {
          color: #666666;
          line-height: 26px;
        }
      }
    }
  }
}
</style>